import { Logo, MultiContainer } from '@shared/ui'
import styles from './Header.module.scss'
import { Navbar } from '../navbar/Navbar'
import { LanguageSelect } from '@features/languages'
import { CustomButton } from '@shared/ui'
import { routes } from '@shared/constants/constants'
import { useTranslation } from 'react-i18next'


export const Header = () => {

  const { t } = useTranslation()

  return (
    <header>
      <MultiContainer className={styles.multiContainer}>
        <div className={styles.container}>
          <Logo className={styles.logo} />
          <Navbar />
          <div className={styles.right}>
            <LanguageSelect />
            <CustomButton
              className={styles.btn}
              to={routes.kitAward}
              variant='blue'
              actionType='link'
            >
              {t('buttons.leaveRequest')}
            </CustomButton>
          </div>
        </div>
      </MultiContainer>
    </header>
  )
}
